module.exports = __webpack_public_path__ + "static/media/04_Follo_Terminer_campagne.c6ccece3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/advertisers/modules/tutorials/assets/pdfs/fr/04_Follo_Terminer_campagne.pdf
// module id = ./src/advertisers/modules/tutorials/assets/pdfs/fr/04_Follo_Terminer_campagne.pdf
// module chunks = 8